var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRipple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#2D2D3B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.88043 6.81977C7.58753 6.52687 7.11266 6.52687 6.81977 6.81977C6.52687 7.11266 6.52687 7.58753 6.81977 7.88043L7.79309 8.85375C8.42114 9.48181 8.9248 9.98548 9.36531 10.3594C9.81786 10.7436 10.2529 11.0348 10.7578 11.1989C11.5652 11.4612 12.435 11.4612 13.2423 11.1989C13.7473 11.0348 14.1823 10.7436 14.6349 10.3594C15.0754 9.98548 15.579 9.48183 16.2071 8.85377L17.1804 7.88043C17.4733 7.58753 17.4733 7.11266 17.1804 6.81977C16.8875 6.52687 16.4127 6.52687 16.1198 6.81977L15.1693 7.77019C14.5131 8.42642 14.0524 8.8863 13.6641 9.21593C13.2825 9.53988 13.0205 9.69376 12.7788 9.77228C12.2727 9.93673 11.7275 9.93673 11.2214 9.77228C10.9797 9.69376 10.7177 9.53988 10.3361 9.21593C9.94778 8.88629 9.48708 8.42642 8.83084 7.77018L7.88043 6.81977Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88043 17.1804C7.58753 17.4733 7.11266 17.4733 6.81977 17.1804C6.52687 16.8875 6.52687 16.4127 6.81977 16.1198L7.79309 15.1464C8.42114 14.5184 8.9248 14.0147 9.36531 13.6408C9.81786 13.2566 10.2529 12.9654 10.7578 12.8013C11.5652 12.539 12.435 12.539 13.2423 12.8013C13.7473 12.9654 14.1823 13.2566 14.6349 13.6408C15.0754 14.0147 15.579 14.5184 16.2071 15.1464L17.1804 16.1198C17.4733 16.4127 17.4733 16.8875 17.1804 17.1804C16.8875 17.4733 16.4127 17.4733 16.1198 17.1804L15.1693 16.23C14.5131 15.5738 14.0524 15.1139 13.6641 14.7843C13.2825 14.4603 13.0205 14.3064 12.7788 14.2279C12.2727 14.0635 11.7275 14.0635 11.2214 14.2279C10.9797 14.3064 10.7177 14.4603 10.3361 14.7843C9.94778 15.1139 9.48708 15.5738 8.83084 16.23L7.88043 17.1804Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRipple);
export default __webpack_public_path__ + "static/media/ripple.8bc96cda40bf6dbe3c0d61d38b7da254.svg";
export { ForwardRef as ReactComponent };